<template>
  <div class="billTo">
    <b-row>
      <b-col md="6">
        <b-row>
          <b-col>
            <eb-select
              v-if="!loading"
              type="text"
              v-model="office.category"
              :options="categoryOptions"
              label="label"
              placeholder="Select Category"
              :selected="office.category"
              class="border-style"
              :disabled="true"
            ></eb-select>
            <slot name="name" :data="office.officeName">
              <c-input
                inputType="text"
                :inputId="`userName`"
                lableText="Office Name"
                v-model="office.officeName"
                class="mt-3"
              />
            </slot>
          </b-col>
        </b-row>
        <div v-if="!setValues" class="mt-3">
          <b-row v-for="(e, idx) in office.email" :key="idx">
            <b-col md="10" class="pr-0">
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                name="Email"
                v-if="!setValues"
              >
                <c-input
                  inputType="Email"
                  :inputId="`email`"
                  lableText="Email"
                  v-model="e.mailId"
                />
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>
            <b-col v-if="!setValues" md="2" class="pl-0">
              <b-button
                btn-special="primary2"
                size="lg"
                @click="onClickEamilButton(e, idx)"
              >
                <i class="fa fa-plus-circle mr-1"></i>
                {{ e.text }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <GmapAutocomplete
                @place_changed="placechange1"
                class="location-search"
                :options="{
                  fields: [
                    'geometry',
                    'formatted_address',
                    'address_components',
                  ],
                }"
              ></GmapAutocomplete>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="12">
              <c-input
                type="text"
                :inputId="`country`"
                readonly
                v-model="office.address.country"
                lableText="Country"
              />
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6">
              <c-input
                type="text"
                :inputId="`state`"
                readonly
                v-model="office.address.state"
                lableText="State"
              />
            </b-col>
            <b-col md="6">
              <c-input
                type="text"
                :inputId="`city`"
                readonly
                v-model="office.address.city"
                lableText="City"
              />
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="12">
              <ValidationProvider
                rules="required|number"
                v-slot="{ errors }"
                name="zipcode"
              >
                <c-input
                  inputType="number"
                  :inputId="`zipcode`"
                  v-model="office.address.zip"
                  lableText="Zipcode"
                />
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col md="6">
        <b-row v-for="(p, idx) in office.phone" :key="p + `${idx}`">
          <b-col v-if="!setValues" md="10" class="pr-0">
            <ValidationProvider
            rules="required|max:15|min:15"
              v-slot="{ errors }"
              name="phone number"
            >
              <TelInput
                :inputType="`number`"
                v-model="p.number"
                @validate="(e) => isValidate(e, p)"
                class="m-0 phn"
                :defaultInput="p.number"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col v-if="!setValues" md="2" class="pl-0">
            <b-button
              btn-special="primary2"
              size="lg"
              @click="onClickPhoneButton(p, idx)"
            >
              <i class="fa fa-plus-circle mr-1"></i>
              {{ p.text }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <GmapMap
              :center="position"
              :zoom="7"
              map-type-id="terrain"
              class="map"
            >
              <GmapMarker label="★" :draggable="true" :position="position" />
            </GmapMap>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5"></b-col>
      <b-col md="2">
        <slot name="footer-button" :data="office">
          <b-button
            class="btn btn-block mt-3"
            btn-color="primary"
            @click="(e) => $emit('onClickOffice', office)"
            >Save</b-button
          >
        </slot>
      </b-col>
      <b-col md="5"></b-col>
    </b-row>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/Common/CustomInput";
import TelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import { mapGetters } from "vuex";
import locationMixins from "@/mixins/addressLocation";
export default {
  name: "billTo",
  mixins: [locationMixins],
  data() {
    return {
      loading: false,
      position: {
        lat: 0,
        lng: 0,
      },
      offficeCategoryDataWatch: "",
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        category: "",
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
          },
        ],
        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add",
            isValid: false,
          },
        ],
        address: {
          country: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  props: {
    tenants: Array,
    officeData: Object,
    setValues: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    TelInput,
    ebSelect,
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    tenantOptions() {
      return this.tenants
        ? this.tenants.map((t) => ({
            label: t.authentication.userName,
            value: t._id,
          }))
        : [];
    },
    categoryOptions() {
      let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
      if (userdata.enableManufacturer) {
        return [
          {
            label: "SELLER",
            value: "SELLER",
          },
          {
            label: "DISTRIBUTOR",
            value: "DISTRIBUTOR",
          },
          {
            label: "DEALER",
            value: "DEALER",
          },
          {
            label: "RESTAURANT",
            value: "RESTAURANT",
          },
          {
            label: "MANUFACTURER",
            value: "MANUFACTURER",
          },
        ];
      } else {
        return [
          {
            label: "SELLER",
            value: "SELLER",
          },
          {
            label: "DISTRIBUTOR",
            value: "DISTRIBUTOR",
          },
          {
            label: "DEALER",
            value: "DEALER",
          },
          {
            label: "RESTAURANT",
            value: "RESTAURANT",
          },
        ];
      }
    },
  },
  watch: {
    setValues() {
      this.useOfficeData();
    },
  },
  methods: {
    async placechange1(e) {
      let place = await e;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.area = mapdata.data.Area ? mapdata.data.Area : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat],
        };
      }
    },
    useOfficeData() {
      if (!this.setValues) return;
      this.office = this.officeData;
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    getState(payload) {
      this.setCity(payload.id);
      this.office.address.state = payload.name;
    },
    async getCity(payload) {
      this.office.address.city = payload.name;
    },
    async setCountry() {
      this.countries = await csc.getAllCountries();
    },
    async setState(id) {
      this.states = await csc.getStatesOfCountry(id);
    },
    async setCity(id) {
      this.cities = await csc.getCitiesOfState(id);
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office?.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "R",
        });
      else this.office?.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office?.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "R",
        });
      else this.office?.phone.splice(idx, 1);
    },
  },
  mounted() {
    this.loading = true;
    this.setCountry();
    if (
      Array.isArray(this.partnerAllData?.bill_to) &&
      this.partnerAllData?.bill_to?.length > 0
    ) {
      let category = {
        label: this.partnerAllData?.category,
        value: this.partnerAllData?.category,
      };

      this.office = this.partnerAllData?.bill_to[0];
      this.office.category = category;
      this.position.lng =
        this.partnerAllData?.bill_to[0]?.address?.location?.coordinates[0];
      this.position.lat =
        this.partnerAllData?.bill_to[0]?.address?.location?.coordinates[1];
    } else {
      this.office = this.partnerAllData?.office;
      this.position.lng =
        this.partnerAllData?.office?.address?.location?.coordinates[0];
      this.position.lat =
        this.partnerAllData?.office?.address?.location?.coordinates[1];
    }
    this.loading = false;
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 39px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}
[btn-special="primary2"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 40px;
  background-color: var(--primary);
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
.border-style {
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #d2d2d2;
  height: 33px;
  border-radius: 4px;
}
.billTo {
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 20px;
}
.phn {
  max-height: 36px;
  font-size: 100%;
}
.border-style-input {
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #d2d2d2;
  height: 37px;
  border-radius: 4px;
}
.map {
  width: 340px;
  height: 300px;
}
</style>
